import { render } from "./LoginPopup.vue?vue&type=template&id=5d806f1c&scoped=true&ts=true"
import script from "./LoginPopup.vue?vue&type=script&lang=ts"
export * from "./LoginPopup.vue?vue&type=script&lang=ts"

import "./LoginPopup.vue?vue&type=style&index=0&id=5d806f1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d806f1c"]])

export default __exports__